import { Step } from 'react-joyride';
import './tourSteps.css';

const tourSteps:Step[] = [{
    target: '#menu-catalog',
    content: (
      <>
        <h6 className="stepTitle">Your projects catalog</h6>
        <p className="stepText">
          Complete your most pressing work with Project Catalog. Click here to access and manage all your projects in just a few clicks.
        </p>
      </>
    ),
    data: {
      next: '/catalog',
    },
    disableBeacon: true,
    placementBeacon: 'right' as const,
    placement: 'right'
  },
  {
    target: '#btn-new-project',
    content: (
      <>
        <h6 className="stepTitle">Creating a Project</h6>
        <p className="stepText">
          To create a Project, go to the "Catalog" section. This will display the list of projects currently assigned to your user account.
          Next, click on the "New Project" button, that displays first in the project list:
        </p>
      </>
    ),
    data: {
      previous: '/',
      next: '/catalog/7C3434EC45B34918B6B6B584A4F99101',
    },
    disableBeacon: false,
    placementBeacon: 'top' as const,
    placement: 'left'
  },
  {
    target: '#add-object-btn',
    content: (
      <>
        <h6 className="stepTitle">Adding spatial entities to a project</h6>
        <p className="stepText">
        You can use the WebUI to add new spatial entities. Load the project's page first and select the “Catalog” section. Then click on the “Add” dropdown to display the list of entities available for creation.
        </p>
      </>
    ),
    data: {
      previous: '/catalog',
    },
    disableBeacon: false,
    placementBeacon: 'top' as const,
    placement: 'left'
}]

export default tourSteps;